export default {"src":"/_next/static/media/proven-results.2be86b60.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};